import { cn } from "../../lib/utils";

interface SkeletonProps {
    className?: string;
}

export function Skeleton({ className }: SkeletonProps) {
    return <div className={cn("animate-pulse rounded-md bg-muted", className)} />;
}

export function StoryCardSkeleton() {
    return (
        <div className="bg-card border border-border rounded-lg p-4 space-y-3">
            <div className="flex items-start justify-between">
                <div className="space-y-2 flex-1">
                    <Skeleton className="h-5 w-3/4" />
                    <Skeleton className="h-4 w-1/2" />
                </div>
                <Skeleton className="h-8 w-8 rounded-full" />
            </div>
            <div className="space-y-2">
                <Skeleton className="h-3 w-full" />
                <Skeleton className="h-3 w-5/6" />
            </div>
            <div className="flex items-center justify-between pt-2">
                <Skeleton className="h-6 w-20" />
                <Skeleton className="h-4 w-16" />
            </div>
        </div>
    );
}

export function StoryTableSkeleton({ count = 6 }: { count?: number }) {
    return (
        <div className="bg-card border border-border rounded-lg overflow-hidden">
            <table className="w-full">
                <thead className="border-b">
                    <tr>
                        <th className="text-left p-4">
                            <Skeleton className="h-4 w-8" />
                        </th>
                        <th className="text-left p-4">
                            <Skeleton className="h-4 w-12" />
                        </th>
                        <th className="text-left p-4">
                            <Skeleton className="h-4 w-16" />
                        </th>
                        <th className="text-left p-4">
                            <Skeleton className="h-4 w-12" />
                        </th>
                        <th className="text-left p-4">
                            <Skeleton className="h-4 w-16" />
                        </th>
                        <th className="text-left p-4">
                            <Skeleton className="h-4 w-8" />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {Array.from({ length: count }, (_, i) => (
                        <tr key={i} className="border-b">
                            <td className="p-4">
                                <Skeleton className="h-12 w-12 rounded" />
                            </td>
                            <td className="p-4">
                                <Skeleton className="h-4 w-32" />
                            </td>
                            <td className="p-4">
                                <div className="space-y-1">
                                    <Skeleton className="h-2 w-20 rounded-full" />
                                    <Skeleton className="h-3 w-12" />
                                </div>
                            </td>
                            <td className="p-4">
                                <Skeleton className="h-5 w-16 rounded-full" />
                            </td>
                            <td className="p-4">
                                <Skeleton className="h-3 w-20" />
                            </td>
                            <td className="p-4">
                                <div className="flex gap-2">
                                    <Skeleton className="h-8 w-16" />
                                    <Skeleton className="h-8 w-8" />
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export function StoryGridSkeleton({ count = 6 }: { count?: number }) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {Array.from({ length: count }, (_, i) => (
                <StoryCardSkeleton key={i} />
            ))}
        </div>
    );
}
